export const INDIA_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh",
  "Chhattisgarh", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh",
  "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
  "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha",
  "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
  "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Dadra and Nagar Haveli", "Daman and Diu", "Lakshadweep",
];

export const indiaMapDefault = {
  eyebrow_en: "Nationwide presence",
  eyebrow_hi: "पूरे देश में मौजूदगी",
  heading_en: "Our Presence Across India",
  heading_hi: "पूरे भारत में हमारी मौजूदगी",
  subtitle_en: "Trusted by accommodations in 24+ states and 318 cities — from the Himalayas to the coast.",
  subtitle_hi: "हिमालय से लेकर समुद्र तट तक — 24+ राज्यों और 318 शहरों की एकोमोडेशन का भरोसा।",
  states_count: "24+",
  cities_count: "318",
  accommodations_count: "1500+",
  map_image: "https://customer-assets-0z36b82j.emergentagent.net/job_booking-boost-12/artifacts/fjuqx13t_Simple%20Clean%20Minimalist%20Planner.png",
  states: [
    "Jammu and Kashmir", "Himachal Pradesh", "Punjab", "Chandigarh", "Haryana",
    "Uttarakhand", "Delhi", "Rajasthan", "Uttar Pradesh", "Bihar", "Gujarat",
    "Madhya Pradesh", "Jharkhand", "West Bengal", "Maharashtra", "Chhattisgarh",
    "Odisha", "Telangana", "Goa", "Karnataka", "Andhra Pradesh", "Tamil Nadu",
    "Kerala", "Arunachal Pradesh", "Assam", "Andaman and Nicobar Islands",
  ],
};
